<template>
  <div>
    <v-text-field
      v-model="formData.tanggal"
      type="date"
      label="Tanggal"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchLaporan"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h1 class="report-title mr-5">BIAYA TRUK HARIAN</h1>
      </div>

      <div class="mt-4">
        <div class="head">
          <table style="width: 100%">
            <tr>
              <td width="20%">TANGGAL</td>
              <td width="2%">:</td>
              <td>{{ formatDate(formData.tanggal) }}</td>
            </tr>
            <tr>
              <td width="20%">TOTAL</td>
              <td width="2%">:</td>
              <td>{{ formatCurrency(grandtotal_biaya) }}</td>
            </tr>
          </table>
        </div>

        <br />

        <template v-for="kv in data" v-if="kv.kv">
          <p><b>KV :</b> {{ kv.kv || "-" }}</p>

          <table style="width: 100%">
            <thead>
              <tr>
                <th class="text-center" width="15%">KA</th>
                <th class="text-center" width="15%">NoSJ</th>
                <th class="text-center" width="10%">KoliSJ</th>
                <th class="text-left" width="45%">Keterangan</th>
                <th class="text-right" width="15%">Truck</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="item in kv.data">
                <tr v-for="detail in item.invoice_detil" :key="detail.id">
                  <td class="text-center">{{ detail.ks }}</td>
                  <td class="text-center">{{ item.no_surat_jalan }}</td>
                  <td class="text-center">
                    {{ detail.container_detil.koli_in }}
                  </td>
                  <td class="text-left">
                    {{ detail.nottb }} /
                    {{ detail.ttb.penerima_detil.nama_lengkap }}
                  </td>
                  <td class="text-right">
                    {{
                      calculatePricePerKs(
                        item.total,
                        item.invoice_detil,
                        detail.container_detil.koli_in,
                        detail
                      )
                    }}
                  </td>
                </tr>
              </template>
              <tr>
                <td colspan="5">
                  <hr />
                </td>
              </tr>
              <tr>
                <td colspan="4" class="text-right pr-2">Total</td>
                <td class="text-right" style="border: 1px solid black">
                  {{ formatCurrency(kv.data.reduce((a, b) => a + b.total, 0)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    grandtotal_biaya() {
      let total = 0;

      this.data.forEach(kv => {
        kv.data.forEach(item => {
          total += item.total;
        });
      });

      return total;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      await axios
        .get(`biaya-truk/laporan-biaya-truk?tanggal=${this.formData.tanggal}`)
        .then(res => {
          if (!res.data) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    calculatePricePerKs(total, allItemRinci, koliIn, rinci) {
      let totalM3 = 0;
      let currentM3 = 0;

      allItemRinci.forEach(item => {
        item.ttb_rinci.forEach(rinci => {
          totalM3 += parseFloat(rinci.m3);
        });
      });

      rinci.ttb_rinci.forEach(rinci => {
        currentM3 += parseFloat(rinci.m3);
      });

      const pricePerM3 = Math.abs(total) / totalM3;

      let price = pricePerM3 * currentM3;

      return this.formatCurrency(price.toFixed(2));
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.head {
  display: flex;
}

table {
  border-collapse: collapse;
}

th {
  font-weight: bold !important;
}

.table-border,
.table-border th,
.table-border td {
  border: 2px solid black;
  border-collapse: collapse;
}

.table-border td {
  padding: 2px;
}

@page {
  size: auto;
}
</style>
